
import { Directive } from '@angular/core';
import { AbstractAdornerDirective } from '@common/directives/abstract-adorner';
import { Adorner } from '@common/data-models/service/adorner';
import { getContrastYIQ } from '@common/utils/util'
import { CriteriaObj } from '@common/data-models/criteria/criteria-obj';

@Directive({
    selector: "[topicCardTypeColor]"
})
export class TopicCardTypeColorDirective extends AbstractAdornerDirective {
    protected locationID = this.globalTablesService.adornersIDS.TopicCardTypeColor;
    protected applyVC(vcToApply: { visibilityCriteria: CriteriaObj, adorner: Adorner }) {
        if (vcToApply && vcToApply.adorner && vcToApply.adorner.Color) {
            this.renderer.setStyle(this.el.nativeElement, "background-color", vcToApply.adorner.Color);
            this.renderer.setStyle(this.el.nativeElement, "color", getContrastYIQ(vcToApply.adorner.Color));
        } else {
            this.renderer.setStyle(this.el.nativeElement, "background-color", "#DBDBDB");
            this.renderer.setStyle(this.el.nativeElement, "color", getContrastYIQ("#DBDBDB"));
        }
    }
}


